import { render, staticRenderFns } from "./previewMenu.vue?vue&type=template&id=4bd20a1d"
import script from "./previewMenu.vue?vue&type=script&lang=js"
export * from "./previewMenu.vue?vue&type=script&lang=js"
import style0 from "./previewMenu.vue?vue&type=style&index=0&id=4bd20a1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports